// API calls for the removable feedback widget. They live here rather than in
// api.js so deleting client/src/feedback removes every client trace except
// one line in App.jsx and one in Settings.jsx.

import { api } from '../api.js'

export const listFeedback = () => api('/api/feedback')

export const sendFeedback = ({ comment, path, area, screenshots }) => {
  const form = new FormData()
  form.append('comment', comment)
  form.append('path', path)
  if (area) form.append('area', area)
  for (const file of screenshots) form.append('screenshots', file)
  return api('/api/feedback', { method: 'POST', body: form, raw: true })
}

export const removeFeedback = (id) => api(`/api/feedback/${id}`, { method: 'DELETE' })
